import React from 'react';
import { getRoute, useNavigate } from '../../../../routes';
import { SurveyCard } from './SurveyCard';

export type IncompleteSurveyProps = {
  name: string;
  estimatedCompletionMinutes?: string;
};

export const IncompleteSurvey = ({
  name,
  estimatedCompletionMinutes,
}: IncompleteSurveyProps): JSX.Element => {
  const navigate = useNavigate();
  const startSurvey = (): void => {
    navigate(getRoute('surveyStart', {}));
  };
  return (
    <SurveyCard
      title={name}
      status="active"
      onActionPress={startSurvey}
      actionLabel="Start"
      actionTestId="pressable-survey-start"
      actionVariant="primary"
      ariaLabel="Start survey"
      estimatedTime={estimatedCompletionMinutes}
    />
  );
};
